"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMergeViewContainer = void 0;
var _view = require("../../actions/view");
var _events = require("../../actions/events");
var _social = require("../../actions/social");
var _selectors = require("./selectors");
var _SocialMergeViewContainer = require("./SocialMergeViewContainer");
var _reactRedux = require("react-redux");
var _source = require("../../selectors/source");
function mapStateToProps(state) {
  return {
    hasInitialError: (0, _selectors.hasErrorSelector)(state),
    isSubmitting: (0, _selectors.isSubmittingSelector)(state),
    email: (0, _selectors.emailSelector)(state),
    socialLoginId: (0, _selectors.socialLoginIdSelector)(state),
    socialType: (0, _selectors.socialTypeSelector)(state),
    hasMergeError: (0, _selectors.hasMerdgeErrorSelector)(state),
    mergeError: (0, _selectors.mergeErrorSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeView(view, data) {
      dispatch((0, _view.changeView)(view, data));
    },
    emit(type, event) {
      dispatch((0, _events.emit)(type, event));
    },
    merge(params) {
      dispatch((0, _social.merge)(params));
    }
  };
}
const SocialMergeViewContainer = exports.SocialMergeViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SocialMergeViewContainer.SocialMergeViewContainer);